import { Fragment } from 'react';
import { ExtractionSpecType, PageDimensionsType } from '../types';
import { getContextPages, getPageExtractions } from '../utils/pdfPageUtils';
import PDFPage from '../pdfPage';
import { Header, Label } from 'semantic-ui-react';

type SinglePageViewPropsType = {
    numberOfPages: number;
    currentPage: number;
    handleExtraction: (extractionSpec: ExtractionSpecType) => void;
    extractionSpecs: ExtractionSpecType[];
    selectionDisabled: boolean;
    scale: number;
};
const SinglePageView = ({
    numberOfPages,
    currentPage,
    handleExtraction,
    extractionSpecs,
    selectionDisabled,
    scale,
}: SinglePageViewPropsType) => {
    return (
        <>
            {getContextPages(currentPage).map((pageNumber) => {
                if (pageNumber < 1 || pageNumber > numberOfPages) {
                    return null;
                }
                return (
                    <Fragment key={pageNumber}>
                        <div key={pageNumber}>
                            <PDFPage
                                key={pageNumber}
                                page={pageNumber}
                                handleExtraction={handleExtraction}
                                pendingPageExtractionSpecs={getPageExtractions(pageNumber, extractionSpecs)}
                                selectionDisabled={selectionDisabled}
                                scale={scale}
                            />
                        </div>
                        <Header>
                            <Label size="big">Page {pageNumber}</Label>
                        </Header>
                    </Fragment>
                );
            })}
        </>
    );
};

export default SinglePageView;
